var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3646 18.4261C38.6185 19.6923 39.8724 20.9586 39.8724 20.9586C41.5614 19.253 41.5699 17.556 39.898 15.8676C38.6441 14.6014 37.8082 13.7572 37.8125 12.9087C35.7012 15.0407 35.6927 16.7377 37.3646 18.4261Z",
    fill: "#6B5325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7313 29.0301C37.7356 28.1816 38.5801 27.3288 39.8469 26.0496C41.5359 24.3439 41.5444 22.6469 39.8725 20.9586C39.8725 20.9586 38.6058 22.2378 37.339 23.517C35.65 25.2227 35.6415 26.9197 37.7313 29.0301Z",
    fill: "#B58C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6172 3.6228C27.777 3.62712 26.941 2.78295 25.6871 1.51668C24.0152 -0.171666 22.3348 -0.163025 20.6458 1.54261C20.6458 1.54261 21.8997 2.80887 23.1536 4.07513C24.8255 5.76348 26.5059 5.75484 28.6172 3.6228Z",
    fill: "#FFC557"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1125 4.10105C19.3792 2.82183 20.646 1.5426 20.646 1.5426C18.9741 -0.145748 17.2937 -0.137107 15.6047 1.56852C14.3379 2.84775 13.4934 3.70056 12.6532 3.70488C14.7431 5.81532 16.4235 5.80668 18.1125 4.10105Z",
    fill: "#B58C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8128 12.9088C39.9241 10.7768 39.9326 9.07977 37.4248 6.54725L34.917 4.01472C32.4091 1.4822 30.7287 1.49084 28.6174 3.62287C29.4577 3.61855 30.7299 4.86634 32.3835 6.57317L34.8913 9.10569C36.5453 10.812 37.8171 12.0603 37.8128 12.9088Z",
    fill: "#B58C3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6533 3.70496C10.5635 1.59452 8.88302 1.60316 6.34953 4.1616L3.81603 6.72005C1.28254 9.2785 1.27398 10.9755 3.36384 13.0859C3.36811 12.2374 4.61675 10.9399 6.32386 9.25258L8.85735 6.69413C10.564 5.00632 11.8131 3.70928 12.6533 3.70496Z",
    fill: "#FFC557"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4419 38.4111C30.5318 40.5215 32.2122 40.5129 34.7457 37.9545L37.2792 35.396C39.8127 32.8376 39.8213 31.1406 37.7314 29.0301C37.7271 29.8786 36.4785 31.1761 34.7714 32.8635L32.2379 35.4219C30.5313 37.1097 29.2822 38.4068 28.4419 38.4111Z",
    fill: "#FFC557"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4175 12.004H19.3314C21.3963 12.004 23.198 12.4053 24.7365 13.2041C26.275 14.0068 27.4687 15.1552 28.3139 16.6533C29.1592 18.1514 29.5818 19.8999 29.5818 21.9027C29.5818 25.2208 28.6661 27.7361 26.831 29.4409C24.9997 31.1496 22.4788 32 19.2758 32H12.4175V12V12.004ZM19.6762 27.0248C21.0478 27.0248 22.1007 26.5679 22.8384 25.6499C23.5761 24.736 23.9468 23.4842 23.9468 21.9027C23.9468 20.492 23.5724 19.3197 22.8273 18.3819C22.0821 17.4441 21.0552 16.9791 19.7577 16.9791H17.9412V27.0209H19.6762V27.0248Z",
    fill: "#3E3F41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLogoColor);
export default __webpack_public_path__ + "static/media/d-logo-color.098c320d7bfc815b663ff73ba074eac7.svg";
export { ForwardRef as ReactComponent };